import { ReactNode } from 'react';

export type SubItemProps = {
  leftBorderColor?: string;
  children: ReactNode;
  connector?: boolean;
  typeSubItemIsFaq?: boolean;
};

const SubItem = ({
  children,
  leftBorderColor,
  connector,
  typeSubItemIsFaq,
}: SubItemProps) => {
  return typeSubItemIsFaq ? (
    <div className="bg-[#070707] text-white h-[182px] w-full mb-2 mt-3 rounded-md shadow-md">
      <div className="flex flex-col h-full w-[95%] mx-auto overflow-y-auto scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent">
        <div className="py-4">{children}</div>
      </div>
    </div>
  ) : (
    <div className="flex flex-row w-full cursor-pointer">
      <div
        className={`flex flex-col w-full relative mt-2 before:content-[''] before:h-0.5 before:bg-[#616161] before:absolute before:left-[-60px] before:top-[50%] ${connector ? 'before:w-[60px]' : ''}`}
      >
        <div
          className="flex flex-col border-l-[10px] rounded-lg relative left-[-5px] bg-black px-4 py-3 z-10"
          style={{ borderLeftColor: leftBorderColor }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default SubItem;